var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCorporateIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 180,
    height: 180,
    viewBox: "0 0 180 180",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: "92.343%",
    x2: "5.646%",
    y1: "76.098%",
    y2: "24.734%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFA14F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#DB4C6D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: "100%",
    x2: "0%",
    y1: "50%",
    y2: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFA14F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#DB4C6D"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 90,
    cy: 90,
    r: 90,
    fill: "url(#a)",
    opacity: 0.146
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M140.207 128.4c.99 0 1.793.805 1.793 1.8s-.802 1.8-1.793 1.8H39.793A1.796 1.796 0 0 1 38 130.2c0-.995.802-1.8 1.793-1.8h4.356a4.692 4.692 0 0 1-.172-1.2V52.8c0-2.64 2.152-4.8 4.782-4.8h32.275c2.63 0 4.782 2.16 4.782 4.8v10.972c.384-.101.78-.172 1.195-.172h12.03a4.198 4.198 0 0 1-.077-.75v-1.685c0-2.64 2.153-4.8 4.782-4.8h14.345c2.63 0 4.781 2.16 4.781 4.8v1.685c0 .257-.032.505-.076.75h8.445c2.63 0 4.782 2.16 4.782 4.8v58.8c0 .416-.07.814-.172 1.2h4.356zm-90.739.148h31.921c.641 0 1.182-.552 1.182-1.205V52.657c0-.653-.541-1.205-1.182-1.205H49.468c-.64 0-1.182.552-1.182 1.205v74.686c0 .653.541 1.205 1.182 1.205zm37.733 0h44.455c.65 0 1.201-.548 1.201-1.196V68.757c0-.648-.55-1.195-1.201-1.195H87.2c-.65 0-1.201.547-1.201 1.195v58.595c0 .648.55 1.196 1.201 1.196zm-14.344-16.11a1.72 1.72 0 0 1 1.714 1.726 1.72 1.72 0 0 1-1.714 1.726h-16a1.72 1.72 0 0 1-1.714-1.726 1.72 1.72 0 0 1 1.714-1.726h16zm0-11.506a1.72 1.72 0 0 1 1.714 1.726 1.72 1.72 0 0 1-1.714 1.726h-16a1.72 1.72 0 0 1-1.714-1.726 1.72 1.72 0 0 1 1.714-1.726h16zm0-11.507a1.72 1.72 0 0 1 1.714 1.726 1.72 1.72 0 0 1-1.714 1.726h-16a1.72 1.72 0 0 1-1.714-1.726 1.72 1.72 0 0 1 1.714-1.726h16zm0-12.658a1.72 1.72 0 0 1 1.714 1.726 1.72 1.72 0 0 1-1.714 1.726h-16a1.72 1.72 0 0 1-1.714-1.726 1.72 1.72 0 0 1 1.714-1.726h16zm0-12.657a1.72 1.72 0 0 1 1.714 1.726 1.72 1.72 0 0 1-1.714 1.726h-16a1.72 1.72 0 0 1-1.714-1.726 1.72 1.72 0 0 1 1.714-1.726h16zm29.714 48.328a1.72 1.72 0 0 1 1.715 1.726 1.72 1.72 0 0 1-1.715 1.726h-8a1.72 1.72 0 0 1-1.714-1.726 1.72 1.72 0 0 1 1.714-1.726h8zm0-11.506a1.72 1.72 0 0 1 1.715 1.726 1.72 1.72 0 0 1-1.715 1.726h-8a1.72 1.72 0 0 1-1.714-1.726 1.72 1.72 0 0 1 1.714-1.726h8zm0-11.507a1.72 1.72 0 0 1 1.715 1.726 1.72 1.72 0 0 1-1.715 1.726h-8a1.72 1.72 0 0 1-1.714-1.726 1.72 1.72 0 0 1 1.714-1.726h8zm0-12.658a1.72 1.72 0 0 1 1.715 1.726 1.72 1.72 0 0 1-1.715 1.726h-8a1.72 1.72 0 0 1-1.714-1.726 1.72 1.72 0 0 1 1.714-1.726h8zm20.572 35.671a1.72 1.72 0 0 1 1.714 1.726 1.72 1.72 0 0 1-1.714 1.726h-8a1.72 1.72 0 0 1-1.714-1.726 1.72 1.72 0 0 1 1.714-1.726h8zm0-11.506a1.72 1.72 0 0 1 1.714 1.726 1.72 1.72 0 0 1-1.714 1.726h-8a1.72 1.72 0 0 1-1.714-1.726 1.72 1.72 0 0 1 1.714-1.726h8zm0-11.507a1.72 1.72 0 0 1 1.714 1.726 1.72 1.72 0 0 1-1.714 1.726h-8a1.72 1.72 0 0 1-1.714-1.726 1.72 1.72 0 0 1 1.714-1.726h8zm0-12.658a1.72 1.72 0 0 1 1.714 1.726 1.72 1.72 0 0 1-1.714 1.726h-8a1.72 1.72 0 0 1-1.714-1.726 1.72 1.72 0 0 1 1.714-1.726h8zM102 62.247c0 .27.122.514.299.712h16.546c.177-.198.298-.441.298-.712v-1.6c0-.618-.56-1.14-1.225-1.14h-14.694c-.662 0-1.224.522-1.224 1.14v1.6z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorporateIcon);
export default __webpack_public_path__ + "static/media/corporate-icon.23e0a7b44866800985c92574584c9ba5.svg";
export { ForwardRef as ReactComponent };